import React from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
} from 'src/utilities/notifications';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { corporateFormDefaultValues } from 'src/components/enterprise/features/Corporate/components/Form/constants/CorporateDefaultValues';
import { CorporateForm } from 'src/components/enterprise/features/Corporate/components/Form/CorporateForm';
import { CorporateFieldsProvider } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsProvider';
import { useCreateCorporate } from 'src/components/enterprise/features/Corporate/CreatePage/hooks/useCreateCorporate';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { getWindow } from 'src/utilities/window';

export const CorporateCreatePage: React.FC = () => {
  const window = getWindow();
  const onSuccess = async (): Promise<void> => {
    window.location.href = `${window.location.origin}/groupadmin/corps`;
  };
  const onError = async (
    error: IErrorResponse | SdkErrorResponse
  ): Promise<void> => {
    pushErrorFromAPI(error);
  };
  const { createCorp } = useCreateCorporate({
    onSuccess,
    onError,
  });

  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Add New Client" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Corps',
              href: `/groupadmin/corps`,
            },
          ]}
        />
      </PageHeader>

      <CorporateFieldsProvider>
        <CorporateForm
          defaultValues={corporateFormDefaultValues}
          onSubmit={createCorp}
        />
      </CorporateFieldsProvider>
    </Square>
  );
};
